"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var users;
        (function (users) {
            var create;
            (function (create) {
                function init() {
                    addEvents();
                }
                create.init = init;
                function addEvents() {
                    $('#saveLink').click(function () {
                        $('form#appnForm').submit();
                    });
                    $('#btn-genIntegrationKey1').on('click', function (e) {
                        e.preventDefault();
                        createApiKey(1);
                    });
                    $('#btn-genIntegrationKey2').on('click', function (e) {
                        e.preventDefault();
                        createApiKey(2);
                    });
                }
                function createApiKey(userApiNumber) {
                    const $form = $('form#appnForm');
                    $form.append('<input type="hidden" name="RegenAPIKey' + userApiNumber + '" value="true" />');
                    $('#genKeyInputGroup' + userApiNumber).html('<span class="input-group-sm">' + T('This Key will be generated upon saving this user.') + '</span>');
                }
            })(create = users.create || (users.create = {}));
        })(users = views.users || (views.users = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
